import React from 'react';
import { useParams } from 'react-router-dom';
import GroupDetailContent from './GroupDetailContent';

const GroupDetail = () => {
  const { id } = useParams();
  return <GroupDetailContent groupId={id} variant="page" />;
};

export default GroupDetail;
